// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__Q5Upn","navBtn":"BottomNav_navBtn__Qd4fr","profile":"BottomNav_profile__jaQfP","navPlus":"BottomNav_navPlus__BidCa"};